import {
  BookOpenIcon,
  CheckCircleIcon,
  LockClosedIcon,
} from '@heroicons/react/24/outline';
import { SVGIcon } from 'magical-trails-react';

export interface Props {
  type: 'location' | 'introduction' | 'conclusion' | 'narrative';
  status?:
    | 'untouched'
    | 'awaitingQuestionAnswer'
    | 'locked'
    | 'completed'
    | 'hidden'
    | 'geofenced';
}

function TrailPointItemIcon({ type, status }: Props) {
  if (status === 'locked') {
    return (
      <div className="bg-mt-surface-2 mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
        <LockClosedIcon
          className="text-mt-ink-muted h-6 w-6"
          aria-hidden="true"
        />
      </div>
    );
  }
  if (
    type === 'conclusion' ||
    type === 'introduction' ||
    type === 'narrative'
  ) {
    return (
      <div className="bg-mt-primary-soft mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
        <BookOpenIcon className="text-mt-primary h-6 w-6" aria-hidden="true" />
      </div>
    );
  }
  if (status === 'untouched' || status === undefined) {
    return (
      <div className="bg-mt-danger-soft mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
        <SVGIcon
          icon="map-pin"
          className="text-mt-danger h-6 w-6"
          aria-hidden="true"
        />
      </div>
    );
  }
  if (status === 'awaitingQuestionAnswer') {
    return (
      <div className="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-100">
        <SVGIcon
          icon="help"
          className="h-7 w-7 text-blue-600"
          aria-hidden="true"
        />
      </div>
    );
  }
  if (status === 'geofenced') {
    return (
      <div className="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-100">
        <svg
          className="h-7 w-7 text-blue-600"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
          <path d="m14.5 7.5-5 5" />
          <path d="m9.5 7.5 5 5" />
        </svg>
      </div>
    );
  }
  if (status === 'completed') {
    return (
      <div className="bg-mt-success-soft mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
        <CheckCircleIcon
          className="text-mt-success h-7 w-7"
          aria-hidden="true"
        />
      </div>
    );
  }
  return (
    <div className="bg-mt-primary-soft mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full"></div>
  );
}

export default TrailPointItemIcon;
